import './index_mWeb.css';
import MatchCardMWeb from '../../component/match_card/index_mWeb';
import { FlatListAutoHeight, View } from '../../../component';
import useGame from '../../../utilities/hooks/game';
import FlatList from 'flatlist-react';
import PullToRefresh from 'react-simple-pull-to-refresh';

const LiveMatchListMWeb = ({ liveMatchList, onPressAddSubstitute, onPressMatchCard }: any) => {
  const { gameName, gameType } = useGame();

  const matchCard = (item: any) => {
    return (
      <MatchCardMWeb
        onPressMatchCard={onPressMatchCard}
        onPressAddSubstitute={onPressAddSubstitute}
        key={item._id}
        matchItem={item}
        gameName={gameName}
        gameType={gameType}
      />
    );
  };

  const onRefresh = async () => {
    // await getData();
  };

  return (
    <View className="match-container_mWeb">
      <PullToRefresh onRefresh={onRefresh}>
        <FlatListAutoHeight childClassName="match-list-bottom_mWeb">
          <FlatList
            list={liveMatchList}
            renderItem={matchCard}
            renderOnScroll
            // renderWhenEmpty={renderWhenEmpty}
          />
        </FlatListAutoHeight>
      </PullToRefresh>
    </View>
  );
};

export default LiveMatchListMWeb;
